[
  {
    "version": "0.19.1",
    "date": "2026-10-15",
    "component": "site",
    "changes": [
      "performance improvements on org page loading"
    ]
  },
  {
    "version": "0.19.0",
    "date": "2026-10-15",
    "component": "site",
    "changes": [
      "v2 site beta"
    ]
  },
  {
    "version": "0.18.1",
    "date": "2026-10-15",
    "component": "site",
    "changes": [
      "stability fixes around tracking beats",
      "stamina control ui fix"
    ]
  },
  {
    "version": "4.2.0",
    "date": "2026-10-15",
    "component": "cli",
    "changes": [
      "fairer scoring for forks, pre-start beats and stray calls (StuBehan)"
    ]
  },
  {
    "version": "4.1.0",
    "date": "2026-10-07",
    "component": "cli",
    "changes": [
      "stamina displays correctly in cli",
      "pi tokens count correctly",
      "forked or resumed sessions dont double count",
      "cli calls new tokenderby.co.uk domain"
    ]
  },
  {
    "version": "0.18.0",
    "date": "2026-10-01",
    "component": "site",
    "changes": [
      "5M token per beat cap (fallback)",
      "org names are now case insensitive",
      "added loading animations",
      "added not found pages",
      "graphs take up whole modal"
    ]
  },
  {
    "version": "0.17.0",
    "date": "2026-09-29",
    "component": "site",
    "changes": [
      "updated domain to tokenderby.co.uk"
    ]
  },
  {
    "version": "0.16.1",
    "date": "2026-09-22",
    "component": "site",
    "changes": [
      "fixed bug where stamina was hidden from the race screen"
    ]
  },
  {
    "version": "0.16.0",
    "date": "2026-09-20",
    "component": "site",
    "changes": [
      "removed race model flags",
      "per model counters stored on horse row",
      "removed per beat token cap",
      "scoring rebuilt as pluggable modifier pipeline",
      "refactored org race settings page",
      "fixed bugs where graphs used raw tokens rather than scored tokens",
      "tv scroll can be overwritten by user scroll (elgordomac)",
      "all models weighted equally",
      "fixed bug where cloudfront rewrote error messages into HTML",
      "other generic fixes"
    ]
  },
  {
    "version": "4.0.0",
    "date": "2026-09-20",
    "component": "cli",
    "changes": [
      "fixed bug where tokens were double counted (StuBehan)",
      "pi harness supported (CameronCarlin)",
      "harness list/enable/disable commands",
      "single horse logic fixes (StuBehan)",
      "counters unified behind harness contract",
      "primary model concept removed",
      "added new generic modifier state",
      "stamina read from modifier states",
      "harness + model family separation",
      "renamed claude to anthropic",
      "renamed gemini to google-gemini",
      "renamed codex to open-ai"
    ]
  },
  {
    "version": "3.1.3",
    "date": "2026-09-17",
    "component": "cli",
    "changes": [
      "claim errors display correctly",
      "heartbeat loop logs"
    ]
  },
  {
    "version": "3.1.2",
    "date": "2026-09-17",
    "component": "cli",
    "changes": [
      "potential fix for stalled token counter"
    ]
  },
  {
    "version": "3.1.0",
    "date": "2026-09-15",
    "component": "cli",
    "changes": [
      "claim hats from admin provided packs",
      "london onsite themed limited edition hats"
    ]
  },
  {
    "version": "0.15.1",
    "date": "2026-09-15",
    "component": "site",
    "changes": [
      "added rain to london theme (adefreitas)",
      "London theme temporarily set as default"
    ]
  },
  {
    "version": "0.15.0",
    "date": "2026-09-14",
    "component": "site",
    "changes": [
      "london skyline onsite theme (adefreitas)"
    ]
  },
  {
    "version": "0.14.0",
    "date": "2026-08-25",
    "component": "site",
    "changes": [
      "device linking screen",
      "org management controls"
    ]
  },
  {
    "version": "3.0.0",
    "date": "2026-08-25",
    "component": "cli",
    "changes": [
      "SSO Account Linking",
      "Added login, link, whoami commands",
      "Google Account integration"
    ]
  },
  {
    "version": "2.13.1",
    "date": "2026-08-19",
    "component": "cli",
    "changes": [
      "Added token-derby claim command"
    ]
  },
  {
    "version": "0.13.3",
    "date": "2026-08-18",
    "component": "site",
    "changes": [
      "Added Phosphor theme (adefreitas)"
    ]
  },
  {
    "version": "0.13.2",
    "date": "2026-08-18",
    "component": "site",
    "changes": [
      "Added matrix theme to race UI (adefreitas)"
    ]
  },
  {
    "version": "2.13.0",
    "date": "2026-08-06",
    "component": "cli",
    "changes": [
      "horse stamina mechanic [BETA]",
      "stamina drain shows in terminal"
    ]
  },
  {
    "version": "0.13.1",
    "date": "2026-08-06",
    "component": "site",
    "changes": [
      "added race ui theme picker (adefreitas)"
    ]
  },
  {
    "version": "0.13.0",
    "date": "2026-08-06",
    "component": "site",
    "changes": [
      "horse stamina system [BETA]",
      "horse stamina displays on race UI"
    ]
  },
  {
    "version": "2.12.4",
    "date": "2026-07-30",
    "component": "cli",
    "changes": [
      "race status screen shows division position",
      "race status screen shows division leader & tokens"
    ]
  },
  {
    "version": "0.12.2",
    "date": "2026-07-29",
    "component": "site",
    "changes": [
      "added option to view token graphs mid race"
    ]
  },
  {
    "version": "0.13.0",
    "date": "2026-07-28",
    "component": "site",
    "changes": [
      "added a theme picker on the home page and race header",
      "new themes: Midnight, Turf, Photo Finish and the animated Chromatic Circuit (the original look is now 'Derby')"
    ]
  },
  {
    "version": "0.12.1",
    "date": "2026-07-28",
    "component": "site",
    "changes": [
      "added crowd animation jitter"
    ]
  },
  {
    "version": "0.12.0",
    "date": "2026-07-28",
    "component": "site",
    "changes": [
      "added return to org button on race screen"
    ]
  },
  {
    "version": "2.12.3",
    "date": "2026-07-28",
    "component": "cli",
    "changes": [
      "multiple fixes to prevent stuck cli with large cli usage folders"
    ]
  },
  {
    "version": "0.11.2",
    "date": "2026-07-20",
    "component": "site",
    "changes": [
      "set back minimum cli version"
    ]
  },
  {
    "version": "0.11.1",
    "date": "2026-07-18",
    "component": "site",
    "changes": [
      "updated minimum cli version"
    ]
  },
  {
    "version": "2.12.2",
    "date": "2026-07-18",
    "component": "cli",
    "changes": [
      "hidden incorrect model counts"
    ]
  },
  {
    "version": "0.11.0",
    "date": "2026-07-16",
    "component": "site",
    "changes": [
      "added versioning to site"
    ]
  },
  {
    "version": "0.10.0",
    "date": "2026-07-16",
    "component": "site",
    "changes": [
      "League standings now scroll in the live ticker",
      "Fixed the ticker resetting mid-scroll"
    ]
  },
  {
    "version": "0.9.0",
    "date": "2026-07-07",
    "component": "site",
    "changes": [
      "League racing mode: divisions, standings and season views",
      "Live running-order ticker during a race",
      "End-of-race screen navigation between pages"
    ]
  },
  {
    "version": "2.12.1",
    "date": "2026-07-05",
    "component": "cli",
    "changes": [
      "Org management polish in the web UI",
      "Environment (prod/staging) support hardening"
    ]
  },
  {
    "version": "2.12.0",
    "date": "2026-07-03",
    "component": "cli",
    "changes": [
      "Org management wired into the web UI"
    ]
  },
  {
    "version": "2.11.0",
    "date": "2026-07-03",
    "component": "cli",
    "changes": [
      "New `token-derby env` command to switch environments",
      "Stacks parameterised by environment (prod/staging)"
    ]
  },
  {
    "version": "0.8.0",
    "date": "2026-07-03",
    "component": "site",
    "changes": [
      "Organisation management moved into the UI"
    ]
  },
  {
    "version": "2.10.1",
    "date": "2026-07-02",
    "component": "cli",
    "changes": [
      "Fixed a race stall when the primary CLI has no home directory"
    ]
  },
  {
    "version": "2.10.0",
    "date": "2026-07-02",
    "component": "cli",
    "changes": [
      "Per-conversation primary tracker with a top-N cap and forfeit",
      "Per-race primary_top5 toggle (replaces the env var)",
      "General UI improvements"
    ]
  },
  {
    "version": "0.7.0",
    "date": "2026-06-22",
    "component": "site",
    "changes": [
      "Full-page end-of-race token graph with rank-based line colours",
      "Rotating standings + charts panel on the finished overlay",
      "Name-tag redesign and rolling achievement ticker"
    ]
  },
  {
    "version": "2.9.0",
    "date": "2026-06-21",
    "component": "cli",
    "changes": [
      "Name-tag redesign and rolling achievement ticker on the race view",
      "Live-API demo server (`npm run dev:live`)"
    ]
  },
  {
    "version": "2.8.0",
    "date": "2026-06-11",
    "component": "cli",
    "changes": [
      "Admin dashboard edit mode: rename users/horses, remove hats, delete horses"
    ]
  },
  {
    "version": "0.6.0",
    "date": "2026-06-04",
    "component": "site",
    "changes": [
      "Organisation race rows with live countdowns",
      "Set-and-forget `/org/{name}/live` race view",
      "Live races pinned to the top while the page scrolls"
    ]
  },
  {
    "version": "2.7.0",
    "date": "2026-05-31",
    "component": "cli",
    "changes": [
      "RaceScoreTracker delta protocol for scoring",
      "Fail-loud transcript scanner (no silent undercount)",
      "Anti-farm XP gating on real competition"
    ]
  },
  {
    "version": "2.5.7",
    "date": "2026-05-29",
    "component": "cli",
    "changes": [
      "Delta-protocol tracker state persisted across restarts",
      "Heartbeat payload frozen across retries"
    ]
  },
  {
    "version": "2.5.6",
    "date": "2026-05-28",
    "component": "cli",
    "changes": [
      "Packaging fix"
    ]
  },
  {
    "version": "2.5.5",
    "date": "2026-05-28",
    "component": "cli",
    "changes": [
      "Packaging fix"
    ]
  },
  {
    "version": "2.5.4",
    "date": "2026-05-28",
    "component": "cli",
    "changes": [
      "Subagent transcript scanning + sampler-freeze fix",
      "No free roll at level 1 (anti-farm)"
    ]
  },
  {
    "version": "0.5.0",
    "date": "2026-05-28",
    "component": "site",
    "changes": [
      "Equipped hats rendered on the live race view",
      "Hat catalog page at /catalog",
      "Compact race UI with a TV-mode toggle"
    ]
  },
  {
    "version": "2.5.3",
    "date": "2026-05-27",
    "component": "cli",
    "changes": [
      "Packaging fix"
    ]
  },
  {
    "version": "2.5.2",
    "date": "2026-05-27",
    "component": "cli",
    "changes": [
      "Packaging fix"
    ]
  },
  {
    "version": "2.5.1",
    "date": "2026-05-27",
    "component": "cli",
    "changes": [
      "Packaging fix"
    ]
  },
  {
    "version": "2.5.0",
    "date": "2026-05-27",
    "component": "cli",
    "changes": [
      "Roll horse picker shown as a confirmation step",
      "Cleaner self-upgrade hints",
      "Rainbow Crown hat art"
    ]
  },
  {
    "version": "2.4.0",
    "date": "2026-05-21",
    "component": "cli",
    "changes": [
      "`token-derby update` command",
      "Race-level input/output token mode"
    ]
  },
  {
    "version": "2.3.0",
    "date": "2026-05-21",
    "component": "cli",
    "changes": [
      "Organisation webhooks: `organisation webhook {set,get,clear}`",
      "race.created and race.ended webhooks"
    ]
  },
  {
    "version": "0.4.0",
    "date": "2026-05-19",
    "component": "site",
    "changes": [
      "Mid-race achievement toasts",
      "Live XP shown in the mid-race level chip"
    ]
  },
  {
    "version": "2.0.1",
    "date": "2026-05-18",
    "component": "cli",
    "changes": [
      "Packaging fix for the organisation page release"
    ]
  },
  {
    "version": "2.0.0",
    "date": "2026-05-18",
    "component": "cli",
    "changes": [
      "Organisation page"
    ]
  },
  {
    "version": "0.3.0",
    "date": "2026-05-18",
    "component": "site",
    "changes": [
      "Organisation page"
    ]
  },
  {
    "version": "1.1.0",
    "date": "2026-05-15",
    "component": "cli",
    "changes": [
      "Persistent stable horse identity",
      "Minimum CLI version enforcement"
    ]
  },
  {
    "version": "1.0.0",
    "date": "2026-05-14",
    "component": "cli",
    "changes": [
      "Caller identity and one-horse-per-user",
      "Races version-pinned to the creator's MAJOR.MINOR",
      "Server-side rate cap on heartbeat token claims"
    ]
  },
  {
    "version": "0.2.0",
    "date": "2026-05-14",
    "component": "site",
    "changes": [
      "TV mode with autoscroll and edge-to-edge lanes",
      "Live token count and 30-minute rolling pace per horse",
      "Dirt-track lane background"
    ]
  },
  {
    "version": "0.1.0",
    "date": "2026-04-24",
    "component": "site",
    "changes": [
      "First site: home page, live race view, horse sprites, pending/finished states"
    ]
  },
  {
    "version": "0.1.0",
    "date": "2026-04-23",
    "component": "cli",
    "changes": [
      "First published CLI — run horses in token races driven by Claude Code output"
    ]
  }
]
